module.exports = __webpack_public_path__ + "img/Denniver.edf89a06.png";